import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertNotificationComponent } from './components/form/alert-notification/alert-notification.component';
import { TestFailureModalComponent } from './components/widgets/test-failure-modal/test-failure-modal.component';
import { ConfirmationDialogComponent } from './components/widgets/confirmation-dialog/confirmation-dialog.component';
import { TestLogModalComponent } from './components/widgets/test-log-modal/test-log-modal.component';
import { TwoFactorOtpModalComponent } from './components/widgets/two-factor-otp-modal/two-factor-otp-modal.component';
import { CloneIssueModalComponent } from './components/widgets/clone-issue-modal/clone-issue-modal.component';
import { UserService } from './services/api/user.service';
import { StoreService } from './services/store.service';

declare global {
  interface Window {
    OverlayScrollbarsGlobal: any;
  }
}


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertNotificationComponent, TestFailureModalComponent, ConfirmationDialogComponent, TestLogModalComponent, TwoFactorOtpModalComponent, CloneIssueModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit { 

  

  constructor(
    private userService: UserService,
    private storeService: StoreService
  ) { }


  ngOnInit(): void {

    console.log('AppComoonent init');

    this.storeService.getAuthToken().subscribe(
      (data: any) => {
        if (data && 'accessToken' in data) {
          this.fetchMe();
        }
      }
    )

  }

  fetchMe(): void {

    this.userService.getMe().subscribe((response: any) => {
      if (response.status.code === 200) {
        this.storeService.setUserData(response?.data?.user);
      }
    })
  }
}


